import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap, map, delay } from "rxjs/operators";
import { environment } from '../../environments/environment';
const headers = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};
function _window(): any {
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class DistributorOnboardingService {

  get nativeWindow(): any {
    return _window();
  }
  ServerUrl = environment.ServerUrl;

  constructor(private http: HttpClient) { }



  PostMobEmailInfo(body: any, mobile, email, name): Observable<any[]> {
    let url = `${this.ServerUrl}/api/SignUp/GenerateOTP?MobileNo=${mobile}&FirstName=${name}&EmailID=${email}`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  PostOTPInfo(mobileno: string, otp: string): Observable<any[]> {
    let url = `${this.ServerUrl}/api/SignUp/VerifyOTP?MobileNo=${mobileno}&OTP=${otp}`;
    return this.http.get<any[]>(url).pipe();
  }

  PostSignUpInfo(body: any): Observable<any[]> {
    let url = `${this.ServerUrl}/api/SignUp/SignUp`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  checkARNNotTaken(ARN: string) {
    let url = `${this.ServerUrl}/api/SignUp/CheckARN?ARN=ARN-${ARN}`;
    return this.http.post<any[]>(url, ARN, headers).pipe();
  }
  checkEUINNotTaken(EUIN: string) {
    let url = `${this.ServerUrl}/api/SignUp/CheckEUIN?EUINNO=E${EUIN}`;
    return this.http.get<any[]>(url).pipe();
  }
  checkMobNotTaken(Mob: string) {
    let url = `${this.ServerUrl}/api/SignUp/CheckMobile?MobileNo=${Mob}`;
    return this.http.get<any[]>(url).pipe();
  }
  checkEmailNotTaken(Email: string) {
    let url = `${this.ServerUrl}/api/SignUp/CheckEmail?EmailID=${Email}`;
    return this.http.get<any[]>(url).pipe();
  }
  SendLoginInfo(SubBrokerId: string): Observable<any[]> {
    let url = `${this.ServerUrl}/api/SignUp/SendLoginUserName?SubBrokerId=${SubBrokerId}&ClientBasicInfoId=&UserType=2`;
    return this.http.get<any[]>(url).pipe();
  }
  GetBankList(): Observable<any[]> {
    let url = `${this.ServerUrl}/api/SignUp/GetBankName`;
    return this.http.get<any[]>(url).pipe();
  }
  GetSubscriptionAmount() {
    let url = `${this.ServerUrl}/api/SignUp/SubscriptionAmount`;
    return this.http.get<any[]>(url).pipe();
  }
  /*Payment*/
  CreateCustomer(body: any): Observable<any[]> {
    let url = `${this.ServerUrl}/api/RazorPay/ProccedToPay`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }
  UpdateCustomer(rp_order_id, rp_payment_id, SubBrokerId, rp_customer_id) {
    let url = `${this.ServerUrl}/api/RazorPay/UpdateTransactionStatus?RazorCustId=${rp_customer_id}&RazorCustOrdId=${rp_order_id}&RazorCustOrdPaymntId=${rp_payment_id}&SubBrokerID=${SubBrokerId}`
    //console.log(url)
    return this.http.post<any[]>(url, '', headers).pipe();
  }
  //added by tishya 
  // CreateCustomerRazorPay(body: any, ClientId: String, AcccountNumber: String, JsonStr: String, TotalAmountPay: number, RazorCustId: String): Observable<any[]> {
  //   let url = `${this.ServerUrl}/api/RazorPay/ProccedToPay?ClientBasicInfoId=${ClientId}&RazorCustId=${RazorCustId}&AccountNo=${AcccountNumber}&JsonStr=${JsonStr}&Amount=${TotalAmountPay}`;
  //   return this.http.post<any[]>(url, body, headers).pipe();
  // }

  PaymentVarify(body: any, ClientId: String, payment_id: String, order_id: String): Observable<any[]> {
    let url = `${this.ServerUrl}/api/RazorPay/PaymentVerification?ClientBasicInfoId=${ClientId}&RazorCustId=cust_P1mCOJFa28igUW&RazorCustOrdPaymntId=${payment_id}&RazorCustOrdId=${order_id}`;
    // let url = `${this.ServerUrl}`+ appendurl;
    return this.http.post<any[]>(url, body, headers).pipe();
  }
  CreateCustomerRazorPayTPV(body: any, Jsonstr, ClientBasicInfoId, params, rid = "", jid = "", initiatedBy = "") {
    let url = `${this.ServerUrl}/api/RazorPay/RazorPayMethodTPV?ClientBasicInfoId=${ClientBasicInfoId}&JsonStr=${Jsonstr}&params=${params}&rid=${rid}&jid=${jid}&UserType=3&initiatedBy=${initiatedBy}`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }
  SavingRazorPayResponse(body: any, Jsonstr, ClientBasicInfoId): Observable<any[]> {
    let url = `${this.ServerUrl}/api/RazorPay/SavingRazorPayResponse?ClientBasicInfoId=${ClientBasicInfoId}&JsonStr=${Jsonstr}`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }
  //End
}
